<template>
  <div
    class="modal fade"
    id="ModalUserProfileEdit"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-notify modal-info" role="document">
      <!--Content-->
      <div class="modal-content text-center">
        <!--Header-->
        <div class="modal-header d-flex justify-content-center">
          <p class="heading">ویرایش حساب کاربری</p>
        </div>

        <!--Body-->
        <div class="modal-body px-4 py-2">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <!-- عکس کاربر -->
            <img
              class="img-fluid imgUserProfileEdit rounded-circle shadow"
              v-bind:src="SImageURL"
              alt="user"
            />
            <label class="custom-file-upload d-flex justify-content-center align-items-center mt-2 h7 text-secondary" style="cursor: pointer;">
              <i class="fas fa-camera fa-1x-half ml-1 text-secondary"></i>
              <input
                type="file"
                id="file-selector"
                name="file"
                style="display: none"
                v-on:change="ShowImage"
                accept=".png,.jpg,.jpeg"
              />
              انتخاب فایل تصویر
            </label>
          </div>
          <!-- کادر نام کاربر -->
          <div class="position-relative">
            <input type="text" placeholder="نام کاربر" class="form-control text-center mt-1"
              v-model="UserProfileData.SUserFirstName" autocomplete="off" />
            <i class="far fa-user fa-1x-half position-absolute" style="right: 8px; top: 33%;">
              <span class="mr-1 captionField">نام</span>
            </i>
          </div>
          <!-- کادر نام خانوادگی کاربر -->
          <div class="position-relative">
            <input type="text" placeholder="نام خانوادگی کاربر" class="form-control text-center mt-1"
              v-model="UserProfileData.SUserLastName" autocomplete="off" />
            <i class="fas fa-user fa-1x-half position-absolute" style="right: 8px; top: 33%;">
              <span class="mr-1 captionField">نام خانوادگی</span>
            </i>
          </div>
          <div class="position-relative">
            <input
              type="text"
              placeholder="تلفن همراه"
              class="form-control text-center mt-1"
              v-model="UserProfileData.SMobileNo"
              autocomplete="off"
              style="direction: ltr;"
              maxlength="11"
            />
            <i class="fas fa-mobile-alt fa-1x-half position-absolute" style="right: 10px; top: 33%;">
              <span class="mr-1 captionField">تلفن همراه</span>
            </i>
          </div>
          <div class="position-relative">
            <input
              type="text"
              placeholder="کد ملی"
              class="form-control text-center mt-1"
              v-model="UserProfileData.NPerNationalId"
              autocomplete="off"
              style="direction: ltr;"
              maxlength="11"
            />
            <i class="far fa-address-card fa-1x-half position-absolute" style="right: 6px; top: 33%;">
              <span class="mr-1 captionField">کد ملی</span>
            </i>
          </div>
          <p class="h6 mt-2 text-info">تغییر رمز ورود</p>
          <input
            type="password"
            placeholder="رمز جدید"
            class="form-control text-center mt-1"
            v-model="UserProfileData.NewPassword"
            autocomplete="new-password"
            style="direction: ltr;"
          />
          <input
            type="password"
            placeholder="تکرار رمز جدید"
            class="form-control text-center mt-1"
            v-model="UserProfileData.ConfirmPassword"
            autocomplete="new-password"
            style="direction: ltr;"
          />
        </div>

        <!--Footer-->
        <div class="modal-footer flex-center px-4">
          <!-- <span class="flex-grow-1 text-right text-danger h7">
            {{ errorText }}
          </span> -->
          <a
            class="btn btn-info waves-effect waves-light"
            v-on:click="SaveEditProfile()"
            >ذخیره تغییرات</a
          >
          <a
            class="btn btn-outline-info waves-effect waves-light"
            style="padding-top: 0.375rem; padding-bottom: 0.375rem"
            data-dismiss="modal"
            >انصراف</a
          >
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>
</template>

<script>
import { newRoutes } from "../../../../../main";
export default {
  data() {
    return {
      UserProfileData:{
        NUserCode: 0,
        NPerNationalId: '',
        SUserFirstName: '',
        SUserLastName: '',
        SUserName: '',
        SMobileNo: '',
        SImageName: '',
        SImageUserBase64: '',
        NewPassword: '',
        ConfirmPassword: '',
        ImageFormFile: '',
        NOrgCode: 0,
      },
      SImageURL: '',
      errorText: ''
    };
  },
  props: ['UserData'],
  created() {
    // alert('created');
    // this.getUserData();
  },
  mounted() {
    // رویداد نمایش مودال
    $('#ModalUserProfileEdit').on('shown.bs.modal', this.getUserData);    
    
    // رویداد بسته شدن مودال
    $("#ModalUserProfileEdit").on("hidden.bs.modal", this.HideModal);

  },
  computed: {},
  methods: {
    // دریافت اطلاعات کاربر
    getUserData() {
      this.UserProfileData.NUserCode = this.UserData.NUserCode;
      this.UserProfileData.SImageName = this.UserData.SImageName;
      if (this.UserData.SImageUserBase64 != null && this.UserData.SImageUserBase64 != ''){
        this.SImageURL = 'data:image/png;base64,' + this.UserData.SImageUserBase64;
      } else {
        // چون عکس کاربر ثبت نشده است
        // به صورت موقت از تصویر پیش فرض استفاده کن
        this.SImageURL = this.$store.getters.getImageUrl + "Users/User.png";
      }
      this.UserProfileData.SImageUserBase64 = this.UserData.SImageUserBase64;
      this.UserProfileData.NPerNationalId = this.UserData.NPerNationalId;
      this.UserProfileData.SUserFirstName = this.UserData.SUserFirstName;
      this.UserProfileData.SUserLastName = this.UserData.SUserLastName;
      this.UserProfileData.SUserName = this.UserData.SUserName;
      this.UserProfileData.SMobileNo = this.UserData.SMobileNo;
      this.UserProfileData.NOrgCode = this.UserData.NOrgCode;
      this.UserProfileData.NewPassword = '';
      this.UserProfileData.ConfirmPassword = '';
      this.UserProfileData.ImageFormFile = '';
    },
    // تابع بسته شدن مودال
    HideModal(){
      // alert('close');
      // اعلام اتمام کار مودال
      // this.$destroy();
      // حذف مودال از DOM
      // this.$el.parentNode.removeChild(this.$el);
    },
    // نمایش تصویر انتخاب شده در تگ ایمیج
    ShowImage(event) {
      // فرمت های مجاز برای فایل تصویر
      var AcceptType = ['image/jpeg', 'image/jpg', 'image/png'];
      const file = event.target.files[0];
      // آیا فایلی انتخاب شده است ؟
      if(file != undefined){
        // آیا فایل انتخابی دارای فرمت مجاز است ؟
        if(AcceptType.indexOf(file.type) != -1){
          // آیا سایز فایل کمتر مساوی 200 کیلو بایت است؟
          if(file.size <= 204800){
            // ذخیره نام فایل
            this.UserProfileData.SImageName = file.name;
            // ذخیره آدرس فایل
            this.SImageURL = URL.createObjectURL(file);
            // تبدیل فایل به base64
            var reader = new FileReader();
            let base64String = "";
            reader.onloadend = function() {
              base64String = reader.result.toString().replace("data:", "")
                .replace(/^.+,/, "");
            }
            reader.readAsDataURL(file);
            // دریافت مقدار Base64
            setTimeout(() => {
              this.UserProfileData.ImageFormFile = base64String;
            }, 1000);
          } else {
            // سایز فایل انتخابی بزرگتر از 200 کیلو بایت است
            this.$store.dispatch("notify", {
              notText: "سایز فایل انتخابی بیشتر از 200 کیلو بایت است !\nشما مجاز به ارسال فایل های حجیم نیستید .\nسایز فایل انتخابی : " + parseFloat(file.size / 1024).toFixed(2) + " کیلو بایت",
              timeOut: 4500,
            });
          }
        } else {
          // نوع فایل انتخابی معتبر نمی باشد
          this.$store.dispatch("notify", {
            notText: "نوع فایل انتخابی معتبر نمی باشد !\nانواع مجاز : png / jpg / jpeg",
            timeOut: 3500,
          });
        }
      }
    },

    // ذخیره تغییرات حساب کاربری
    async SaveEditProfile() {
      this.errorText = '';
      this.UserProfileData.SUserName = (this.UserProfileData.SUserFirstName != "" ? this.UserProfileData.SUserFirstName + " " : "") + (this.UserProfileData.SUserLastName != "" ? this.UserProfileData.SUserLastName : "");
      // آیا نام کاربر مقدار دهی شده است ؟
      if(this.UserProfileData.SUserName != ''){
        // آیا موبایل ثبت شده است ؟
        if(this.UserProfileData.SMobileNo != '' && this.UserProfileData.SMobileNo != 0){
          // آیا کد ملی درج شده است ؟
          if(this.UserProfileData.NPerNationalId != ''){
            // آیا کلمه عبور درج شده است و با تکرار آن یکسان است ؟
            if(this.UserProfileData.NewPassword === '' || this.UserProfileData.NewPassword == this.UserProfileData.ConfirmPassword){
              // دریافت توکن احراز هویت
              let token = await this.$store.getters.getUserData.token;
              // ویرایش اطلاعات کاربر در سرور
              var check = await this.$store.dispatch("EditUserProfile", {
                UserProfileData: this.UserProfileData,
                token: token,
              });
              if (check.Status == true){
                $("#ModalUserProfileEdit").modal("hide");
                // اعلام اعمال تغییرات به والد
                this.$emit("EditUser", this.UserProfileData);
                console.log('check ...', check);
                if(check.TimeStampLogin === ""){
                  // توکن کاربر تایید نشد . انتقال به صفحه لاگین
                  newRoutes.push("Login");
                }
              } else {
                this.errorText = check.errorText;
              }
            } else {
              // کلمه عبور با تکرار آن یکسان نیست
              this.$store.dispatch("notify", {
                notText: "کلمه عبور با تکرار آن یکسان نیست !",
                timeOut: 2500,
              });
            }
          } else {
            // ثبت کد ملی الزامی است
            this.$store.dispatch("notify", {
              notText: "عدم درج کد ملی : درج کد ملی الزامی است !",
              timeOut: 2500,
            });
          }
        } else {
          // ثبت تلفن همراه الزامی است
          this.$store.dispatch("notify", {
            notText: "عدم درج تلفن همراه : درج تلفن همراه الزامی است !",
            timeOut: 2500,
          });
        }
      } else {
        // ثبت نام کاربر الزامی است
        this.$store.dispatch("notify", {
          notText: "عدم درج نام : درج نام کاربر الزامی است !",
          timeOut: 2500,
        });
      }
      // در این لحظه باید نسبت به ذخیره اطلاعات در سرور
      // و بروزرسانی اطلاعات محلی اقدام گردد
      console.log(this.UserProfileData);
    },

  },
};
</script>

<style>
.imgUserProfileEdit {
  width: 120px;
  height: 120px;
}
.captionField {
  font-family: 'VazirFD';
    font-weight: 400;
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/RightMenu/Components/UserProfileEdit.vue